// extracted by mini-css-extract-plugin
module.exports = {"ResponsiveMedia":"ResponsiveMedia-module--ResponsiveMedia--3zNMU"};